import logoImage from "../assets/images/logoblue.png";
import emailBg from "../assets/images/email_bg.png";
import mobileApp from "../assets/images/google-play.png";
import applestore from "../assets/images/applestore.png";

export const getEmailTemplate = (
  userData,
  type,
  redirectUrl,
  orgName,
  adminEmail
) => {
  const isContributor = type === "Contributor";
  const headingText = isContributor
    ? "Confirm Your Contributor Invitation"
    : "Confirm Your Admin Invitation";
  const invitationText = isContributor
    ? `You are invited to contribute QuickTales to ${orgName}! You will need to install the QuickTales app using one of the links below. Once you have created your account, you can email ${adminEmail} or go to ${orgName}'s Profile page, tap the three dots in the upper right corner, and request to become a Contributor.`
    : `You have been invited to become an Administrator  ${
        orgName ? "for " + orgName : ""
      } on the QuickTales app! Please click below to confirm your identity.`;
  const additionalText = isContributor
    ? `We look forward to listening to your QuickTales!`
    : `Please let us know if this email was sent in error or you are not ${userData.name}.`;

  return `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Document</title>
      <style>
        body {
          background-color: #00a7cd;
          background-image: url(${emailBg});
          background-size: cover;
          background-repeat: no-repeat;
          font-family: Arial, sans-serif;
        }
  
        .email-container {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
        }
  
        .header {
          text-align: center;
          margin-bottom: 20px;
          position: relative;
          display: flex;
          justify-content: center;
        }
  
        .logo {
          width: 200px;
          height: auto;
          text-align: center;
        }
  
        .email-content {
          padding: 20px;
          background-color: #ffffff;
          border-radius: 10px;
        }

        .app-links {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          gap: 20px;
        }

  
        h1 {
          color: #000;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
          display: flex;
          justify-content: center;
        }
  
        p {
          color: #000;
          font-size: 14px;
          line-height: 1.5;
          margin-bottom: 15px;
        }
  
        .user-info {
          font-size: 14px;
          margin-bottom: 15px;
          color: #333;
        }
  
        .cta-button {
          // display: block;
          display: flex;
          width: fit-content;
          padding: 10px 20px;
          margin: 20px auto;
          color: #007bff;
          text-decoration: underline;
          text-align: center;
          font-weight: bold;
          font-size: 18px;
          justify-content: center;
          margin-left: 100px;
        }
  
        .footer-container {
          text-align: center;
          margin-top: 30px;
        }
  
        .footer-container p {
          color: #ffffff;
          font-size: 12px;
          margin: 5px 0;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="email-content">
          <div class="header">
            <img src="${logoImage}" alt="Logo" class="logo" />
          </div>
          <h1>${headingText}</h1>
          <p>Hi ${userData.name},</p>
          <p>${invitationText}</p>
          <p>${additionalText}</p>
           ${
             !isContributor
               ? `<a href="${redirectUrl}" class="cta-button">Accept</a>`
               : ""
           }
          
          
          <p>Kind regards,</p>
          <p>The QuickTales Team</p>
        </div>
      </div>

      <div class="app-links">
          <div class="app-link">
           <a href="https://quicktales.com">
                                    <img src="${mobileApp}" alt="App Store">
                                </a>
          </div>

         <div class="app-link">
           <a href="https://quicktales.com">
                                 <img src="${applestore}" alt="App Store">
                            </a>
          </div>
     </div>
  
      <footer class="footer-container">
        <p>Support@QuickTales.com</p>
        <p>© 2024 QuickTales</p>
      </footer>
    </body>
  </html>
  `;
};

export default getEmailTemplate;
